<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">How do you get there?</h2>
        </div>

        <div class="step-body">
            <CardSelector
                :options="transportOptions"
                :value="selectedValue"
                :vertical="true"
                @input="onSelect"
            />
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!selectedValue"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>
        </div>
    </div>
</template>

<script>
import CardSelector from '../shared/CardSelector.vue';

export default {
    name: 'TransportationStep',

    components: {
        CardSelector
    },

    data() {
        return {
            transportOptions: [
                {
                    value: 'drive',
                    label: 'I drive',
                    icon: 'mdi-car'
                },
                {
                    value: 'none',
                    label: 'No transportation',
                    icon: 'mdi-walk'
                }
            ]
        };
    },

    computed: {
        selectedValue() {
            return this.$store.getters['Questionnaire/getAnswer']('transportMode');
        }
    },

    methods: {
        onSelect(value) {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'transportMode',
                value
            });
        },

        onNext() {
            if (this.selectedValue) {
                this.$emit('next');
            }
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.step-body {
    flex: 1;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}
</style>
